export enum SideMenuState {
    In = 'in',
    Out = 'out',
}
